//186
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useState, useRef } from 'react';
import * as THREE from 'three';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import { PaintColorMaterial } from '../../utils/materials';

export function Castanet_stool(props) {
  const { nodes, materials, scene } = useGLTF('models/Cast-a-Net Stool.glb');

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  const [material, setMaterial] = useState(null);

  useEffect(() => {
    const loader = new THREE.TextureLoader();

    // Load the normal map
    const normalMap = loader.load(
      'textures/cast-a-net-normal.jpg',
      (texture) => {
        // Set wrap and repeat settings
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.repeat.set(8, 8);
      },
    );

    // Create a new material based on PaintColorMaterial
    const newMaterial = PaintColorMaterial.clone(); // Clone the existing material
    newMaterial.normalMap = normalMap; // Assign the normal map
    newMaterial.needsUpdate = true; // Mark the material for update

    setMaterial(newMaterial);
  }, [PaintColorMaterial]);

  useSetMaterialFinish(
    material,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-cast_a_net_stool-paint_color',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
    //
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      {material && (
        <mesh
          castShadow
          geometry={nodes.Paint_Color.geometry}
          material={material}
        />
      )}
      <Shadow model={'Cast-a-Net Stool'} />
    </group>
  );
}
